import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import blogManifest from '../data/generated/blogManifest.json';
import './LatestBlog.css';

const LatestBlog = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      const elements = sectionRef.current?.querySelectorAll('.fade-in');
      elements?.forEach((el) => {
        el.classList.add('visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px 20px 0px',
      }
    );

    const elements = sectionRef.current?.querySelectorAll('.fade-in');
    elements?.forEach((el) => observer.observe(el));

    const handleResize = () => {
      if (window.innerWidth <= 768) {
        observer.disconnect();
        const elements = sectionRef.current?.querySelectorAll('.fade-in');
        elements?.forEach((el) => {
          el.classList.add('visible');
        });
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (!blogManifest || blogManifest.length === 0) {
    return null;
  }

  const latestPosts = blogManifest.slice(0, 3);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <section className="latest-blog" ref={sectionRef}>
      <div className="latest-blog-container">
        <div className="latest-blog-header fade-in">
          <h2>From the Blog</h2>
          <Link to="/blog" className="latest-blog-view-all">
            View all articles <span>&rarr;</span>
          </Link>
        </div>

        <div className="latest-blog-grid fade-in">
          {latestPosts.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="latest-blog-card"
            >
              <span className="latest-blog-date">{formatDate(post.date)}</span>
              <h3 className="latest-blog-title">{post.title}</h3>
              <p className="latest-blog-description">{post.description}</p>
              <span className="latest-blog-read-more">
                Read more <span>&rarr;</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LatestBlog;
